"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var chat_message_1 = __importDefault(require("./chat-message"));
var unblock_user_modal_1 = __importDefault(require("./unblock-user-modal"));
function MessageHistory(_a) {
    var openChat = _a.openChat, messages = _a.messages, contacts = _a.contacts, updateChat = _a.updateChat, hasNextPageMessages = _a.hasNextPageMessages, isFetchingNextPageMessages = _a.isFetchingNextPageMessages, fetchNextPageMessages = _a.fetchNextPageMessages;
    var senderBlocked = openChat.user_role === "LANDLORD"
        ? openChat.tenant_blocked
        : openChat.landlord_blocked;
    var _b = (0, hooks_1.useIntersectionObserver)({
        root: document.getElementById("chat-window"),
    }), topRef = _b[0], entryTop = _b[1];
    (0, react_1.useEffect)(function () {
        if ((entryTop === null || entryTop === void 0 ? void 0 : entryTop.isIntersecting) &&
            hasNextPageMessages &&
            !isFetchingNextPageMessages) {
            fetchNextPageMessages();
        }
    }, [
        entryTop === null || entryTop === void 0 ? void 0 : entryTop.isIntersecting,
        hasNextPageMessages,
        isFetchingNextPageMessages,
    ]);
    return (react_1.default.createElement("div", { id: "chat-window-history", className: "d-flex flex-column flex-column-reverse flex-grow-1 overflow-auto" },
        senderBlocked && (react_1.default.createElement("div", { id: "sender-blocked-hint", className: "p-2 mb-2 d-flex flex-column align-self-center tc" },
            window.Translator.trans("chat.actions.unblock_hint", {}, "js"),
            react_1.default.createElement(unblock_user_modal_1.default, { triggerElement: react_1.default.createElement("button", null, window.Translator.trans("chat.actions.unblock_chat", {}, "js")), triggerTitle: window.Translator.trans("chat.actions.unblock_chat", {}, "js"), openChat: openChat, updateChat: updateChat }))),
        messages.map(function (item, index, entries) { return (react_1.default.createElement(react_1.Fragment, { key: item.id },
            index === entries.length - 1 && react_1.default.createElement("div", { ref: topRef }),
            react_1.default.createElement(chat_message_1.default, { message: item, openChat: openChat, contacts: contacts }))); }),
        isFetchingNextPageMessages && (react_1.default.createElement("svg", { className: "icon mb-0 gray flex-shrink-0 align-self-center mb-2", width: "20", height: "20" },
            react_1.default.createElement("use", { href: "#loader" })))));
}
exports.default = MessageHistory;
